import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpEvent  } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HttpClientService {

    baseURL: string = environment.apiURL;
    phpBaseURL: string = environment.apiPHPURL;
    phpBaseUrlv2: string = environment.apiPHPURLv2;
    transportURL: string = environment.transportBaseURL;
    sopURL: string = environment.sopURL;
    chatURL: string = environment.chatURL;
    englishVerificationURL: string = environment.englishVerificationURL;
    uelVerificaitonURL: string = environment.uelVerificaitonURL;
    interviewRecordUrl: string = environment.interviewRecordUrl;
    constructor(
        private httpClient: HttpClient,
        private localStorageService: LocalStorageService
    ) {}

    private getHeaderAuth() {
        const token = this.localStorageService.getKey('access_token');
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            }),
        };
        return httpOptions;
    }

    private getHeaderAuthForAccessToken() {
        const token = this.localStorageService.getKey('access_token');
        const httpOptions = {
            headers: new HttpHeaders({
                'username': 'crizac',
                'password': 'crizac123'
            }),
        };
        return httpOptions;
    }

    private getHeaderAuthForFormData() {
        const token = this.localStorageService.getKey('access_token');
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
            }),
        };
        return httpOptions;
    }

    private getHeaderBasicAuth() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'X-Bypass-Token-Replacement': 'true',
                Authorization: 'Basic ' + btoa('akorn:akorn'),
            }),
        };
        return httpOptions;
    }

    private getHeaderBasicAuthForFormData() {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: 'Basic ' + btoa('akorn:akorn'),
                'X-Bypass-Token-Replacement': 'true',
            }),
        };
        return httpOptions;
    }

    private getHeaderBasicAuthForFormDataWithBlob() {
        // const token = this.localStorageService.getKey('access_token');
        // const httpOptions = {
        //     headers: new HttpHeaders({
        //         Authorization: 'Bearer ' + token,
        //         responseType: 'blob',
        //     }),
        // };
        const token = this.localStorageService.getKey('access_token');
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
            }),
            responseType: 'blob',
        };
        return httpOptions;
    }

    private getHeaderBasicAuthForFormDataWithProgress() {
        const token = this.localStorageService.getKey('access_token');
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
            }),
            reportProgress: true,
            observe: 'events',
        };
        return httpOptions;
    }

    private getPasswordResetAuth(token: string) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            }),
        };
        return httpOptions;
    }

    private getDataWithBasicAuthv2(username: string, password: string) {
        const basicAuth = btoa(`${username}:${password}`);
        // Y3JpemFjOmNyaXphYyA=
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: `Basic ${basicAuth}`,
                'X-Bypass-Token-Replacement': 'true',
                // username: 'crizac', // Send username in headers
                // password: 'crizac',
            }),
        };

        return httpOptions;
    }

    private getDataWithBasicAuthv2DirectPDF(username: string, password: string) {
        const basicAuth = btoa(`${username}:${password}`);
        // Y3JpemFjOmNyaXphYyA=
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: `Basic ${basicAuth}`,
                'X-Bypass-Token-Replacement': 'true',
                // username: 'crizac', // Send username in headers
                // password: 'crizac',
            }),
            responseType: 'arraybuffer' as 'json', // Specify response type for PDF
        };

        return httpOptions;
    }

    public getResetPasswordAuth(url: string, payload: any) {
        let httpOptions = this.getPasswordResetAuth(payload.token);
        delete payload.token;
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }

    public get(url: string, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.get<unknown>(
            `${this.baseURL}${url}`,
            httpOptions
        );
    }

    public getWithqueryParams(
        url: string,
        isBasicAuth: boolean = false,
        queryparm
    ) {
        let httpOptions: any = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        httpOptions.params = queryparm;
        return this.httpClient.get<unknown>(
            `${this.baseURL}${url}`,
            httpOptions
        );
    }

    public post(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }
    public postAccessToken(url: string, payload: unknown) {
        let httpOptions = this.getHeaderAuthForAccessToken();
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }
    public postCustom(
        url: string,
        payload: unknown,
        isBasicAuth: boolean = false,
        customBasicAuthCreds?: { username: string; password: string }
    ) {
        let httpOptions;
        // If Basic Auth with custom credentials is provided, use custom headers
        if (isBasicAuth && customBasicAuthCreds) {
            httpOptions = this.getHeaderCustomBasicAuth(
                customBasicAuthCreds.username,
                customBasicAuthCreds.password
            );
        } 
        // If Basic Auth is set to true but no custom credentials, use default hardcoded values
        else if (isBasicAuth) {
            httpOptions = this.getHeaderBasicAuth(); 
        } 
        // Otherwise, use the usual authentication
        else {
            httpOptions = this.getHeaderAuth();
        }
    
        // Add withCredentials: false for Basic Auth requests
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            {
                ...httpOptions,  // Include the existing headers
                withCredentials: false  // Prevent sending cookies/sessions
            }
        );
  }
    private getHeaderCustomBasicAuth(username: string, password: string) {
        const token = this.localStorageService.getKey('access_token');
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
            'username': username,
            'password': password
          });
          return { headers };
      }
    public postMarksheetVerify(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.post<unknown>(
            `${this.englishVerificationURL}${url}`,
            payload,
            httpOptions
        );
    }

    public postUELPrescreening(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.post<unknown>(
            `${this.uelVerificaitonURL}${url}`,
            payload,
            httpOptions
        );
    }
    public postUELPrescreening2(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.post<unknown>(
            `${this.uelVerificaitonURL}${url}`,
            payload,
            httpOptions
        );
    }

    public download(
        url: string,
        payload: unknown,
        isBasicAuth: boolean = false
    ) {
        let httpOptions: any = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        httpOptions = {
            ...httpOptions,
            responseType: 'blob',
        };
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }

    public put(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.put<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }

    public delete(url: string, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.delete<unknown>(
            `${this.baseURL}${url}`,
            httpOptions
        );
    }

    public upload(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuthForFormData();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuthForFormData();
        }
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }
    public uploadpdf<T>(
        url: string,
        payload: unknown,
        isBasicAuth: boolean = false,
        responseType: 'json' | 'blob' = 'json'
      ): Observable<HttpEvent<T>> {
        let httpOptions: any = isBasicAuth
          ? this.getHeaderBasicAuthForFormData()
          : this.getHeaderAuthForFormData();
      
        // Ensure responseType is 'json' or 'blob', and observe is set to 'events' to capture the full HttpEvent
        httpOptions = {
          ...httpOptions,
          responseType: responseType as 'json' | 'blob', // Cast to ensure it's either 'json' or 'blob'
          observe: 'events', // Observe full HTTP events (status, headers, body)
        };
      
        // Make the POST request and return the observable
        return this.httpClient.post<T>(`${this.baseURL}${url}`, payload, httpOptions);
      }
    public uploadWithProgress(
        url: string,
        payload: unknown,
        isBasicAuth: boolean = false
    ) {
        let httpOptions = this.getHeaderBasicAuthForFormData();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderBasicAuthForFormDataWithProgress();
        }
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }

    public csv(url: string) {
        let httpOptions: any = this.getHeaderBasicAuthForFormDataWithBlob();
        return this.httpClient.get(`${this.baseURL}${url}`, httpOptions);
    }

    public zip(url: string) {
        let httpOptions: any = this.getZipHeaderAuth();
        return this.httpClient.get(`${this.baseURL}${url}`, httpOptions);
    }

    public eml(url: string, payload: any) {
        let httpOptions: any = this.getZipHeaderAuth();
        return this.httpClient.post(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }

    private getZipHeaderAuth() {
        const token = this.localStorageService.getKey('access_token');
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            }),
            responseType: 'blob',
        };
        return httpOptions;
    }

    public getPhp(url: string, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.get<unknown>(
            `${this.phpBaseURL}${url}`,
            httpOptions
        );
    }

    public postPhp(url: string, payload, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.post<unknown>(
            `${this.phpBaseURL}${url}`,
            payload,
            httpOptions
        );
    }

    public getPhpV2(url: string, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.get<unknown>(
            `${this.phpBaseUrlv2}${url}`,
            httpOptions
        );
    }

    // Transport API
    public postTransport(url: string, payload, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.post<unknown>(
            `${this.transportURL}${url}`,
            payload,
            httpOptions
        );
    }

    public getTransport(url: string, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.get<unknown>(
            `${this.transportURL}${url}`,
            httpOptions
        );
    }

    public putTransport(url: string, payload, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.put<unknown>(
            `${this.transportURL}${url}`,
            payload,
            httpOptions
        );
    }

    public uploadTransport(
        url: string,
        payload: unknown,
        isBasicAuth: boolean = false
    ) {
        let httpOptions = this.getHeaderBasicAuthForFormData();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuthForFormData();
        }
        return this.httpClient.post<unknown>(
            `${this.transportURL}${url}`,
            payload,
            httpOptions
        );
    }

    public getSOP(url: string, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.get<unknown>(
            `${this.sopURL}${url}`,
            httpOptions
        );
    }
    public postSOP(url: string, payload, isBasicAuth: boolean = false) {
        let httpOptions = this.getDataWithBasicAuthv2('crizac', 'crizac');
        if (!isBasicAuth) {
            httpOptions = this.getDataWithBasicAuthv2('crizac', 'crizac');
        }
        return this.httpClient.post<unknown>(
            `${this.sopURL}${url}`,
            payload,
            httpOptions
        );
    }

    public postSOPPDF(url: string, payload, isBasicAuth: boolean = false) {
        let httpOptions = this.getDataWithBasicAuthv2DirectPDF('crizac', 'crizac');
        if (!isBasicAuth) {
            httpOptions = this.getDataWithBasicAuthv2DirectPDF('crizac', 'crizac');
        }
        return this.httpClient.post<unknown>(
            `${this.sopURL}${url}`,
            payload,
            httpOptions
        );
    }

    public chatUpload(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuthForFormData();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuthForFormData();
        }
        return this.httpClient.post<unknown>(
            `${this.chatURL}${url}`,
            payload,
            httpOptions
        );
    }

    public chatPost(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.post<unknown>(
            `${this.chatURL}${url}`,
            payload,
            httpOptions
        );
    }

    public chatPut(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.put<unknown>(
            `${this.chatURL}${url}`,
            payload,
            httpOptions
        );
    }

    public postPhpForPDF(url: string, payload, isBasicAuth: boolean = false) {
        let httpOptions = this.getDataWithBasicAuthv2DirectPDF('crizac', 'crizac');;
        if (!isBasicAuth) {
            httpOptions = this.getDataWithBasicAuthv2DirectPDF('crizac', 'crizac');;
        }
        return this.httpClient.post<unknown>(
            `${this.phpBaseURL}${url}`,
            payload,
            httpOptions
        );
    }

    public postcondition(url: string, payload, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.post<unknown>(
            `${this.chatURL}${url}`,
            payload,
            httpOptions
        );
    }
    public getcondition(url: string, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.get<unknown>(
            `${this.chatURL}${url}`,          
            httpOptions
        );
    }
    public putcondition(url: string,payload, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.put<unknown>(
            `${this.chatURL}${url}`,
            payload,          
            httpOptions
        );
    }
}
